import type { FormxKpiFieldItem, IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createListFormxKpiFieldsByProjectUseCase({ formxRepository }: Deps) {
  return async function listFormxKpiFieldsByProject(projectId: string): Promise<FormxKpiFieldItem[]> {
    return formxRepository.listKpiFieldsByProject(projectId);
  };
}
